import { inject, Injectable } from "@angular/core";
import { Api, isErrorResponse, isOKResponse } from "@fry-it/risr-core";
import { EasTable, TableSource } from "@fry/lib/store";
import { from, map, Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class BookingAvailableCardSourceFactory {
    private api = inject(Api);

    getTableSource(dashboardId: string, cardId: string): TableSource {
        const endpoint = `/portals/${dashboardId}/cards/${cardId}/available_bookings`;
        const source = {
            table: (params: any): Observable<EasTable> => {
                return from(this.api.post<EasTable>(`${endpoint}/table`, params)).pipe(
                    map(response => {
                        if (isOKResponse(response)) {
                            const table = response.data;
                            return table;
                        }

                        if (isErrorResponse(response)) {
                            throw response.error;
                        }

                        throw new Error('Error fetching table data');
                    })
                );
            }
        }
        return source;
    }
}